import type IntersectionObserverManager from './IntersectionObserverManager';

import { createContext, useContext } from 'react';

interface IntersectionObserverContextType {
    manager: IntersectionObserverManager | null;
}

export const IntersectionObserverContext = createContext<IntersectionObserverContextType>({
    manager: null,
});

export const useIntersectionObserverContext = () => {
    const context = useContext(IntersectionObserverContext);
    if (!context) {
        throw new Error(
            'useIntersectionObserverContext should be used within a IntersectionObserverContext.Provider',
        );
    }
    return context;
};
